import React, {Component} from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import styled from 'styled-components';
import {connect} from 'react-redux';
import UserActions from '../../redux/UserRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import {TextField, SelectField} from '../../components/FormFields';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

class UserPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        fullName: '',
        phone: '',
        dealer: null,
        userRole: null,
        position: '',
        isActive: true,
      },
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== 'new') {
      this.props.get(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (prevProps.user
            && !this.props.user) {
              //пользователь был удален
              this.props.history.goBack();
          } else if (this.props.match.params.id === 'new'
            && this.props.user) {
              //пользователь был добавлен
              this.props.history.goBack();
          } else if (this.props.user) {
            //даные пользователя загружены
            let data = {};
            Object.keys(this.state.user).map(key => data[key] = this.props.user[key])
            this.setState({
              user: data,
            });
          } else {
            //произошла ошибка - дилер не найден, другие ошибки выводим глобально
            this.props.history.goBack();
          }
        
        } else if (!this.state.user.fullName) {
          //произошла ошибка - дилер не найден, другие ошибки выводим глобально
          this.props.history.goBack();
        }
    }
  }

  onDelete = e => {
    e.preventDefault();
    this.props.delete(this.props.user.id);
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {create, update} = this.props;
    const {user} = this.state;
    if (!user.userRole || !user.dealer) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      this.props.match.params.id === 'new'
      ? create(user)
      : update({
        ...user,
        id: this.props.user.id
      });
    }
  }

  onChangeUserStatus = e => {
    e.preventDefault();
    this.props.update({isActive: !this.props.user.isActive , id: this.props.user.id});
  }

  onChange = (name, value) => {
    this.setState({
      user: {...this.state.user, [name]: value},
    });
  }

  render() {
    //name, regionId, cityId, address, iNN, kPP, salesPhone, sTOPhone, webSite, email, description
    const isNew = this.props.match.params.id === 'new';
    const {user} = this.state;
    const {
      dictionaries,
      fetching,
      getDictionaries,
      permissions,
      t,
    } = this.props;
    
    if (!permissions) {
      return <Forbidden />;
    } else if (isNew && !permissions.create) {
      return <Forbidden />;
    }

    const hideControl = !isNew && !permissions.edit;
    const disabled = hideControl || fetching;

    return (
      <ContentWrapper>
        <HeaderContainer>
          <h1>{t(isNew ? 'Create new user' : 'Edit user')}</h1>
          {!isNew && !hideControl && (
            <Button
              appearance='primary'
              onClick={this.onChangeUserStatus}
            >
              {t(user.isActive ? 'Deactivate' : 'Activate')}
            </Button>
          )}
        </HeaderContainer>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <GridColumn medium={12}>
              <TextField
                name='fullName'
                label={t('Full name')}
                required={true}
                onChange={this.onChange}
                placeholder={t('Enter full name')}
                isDisabled={disabled}
                value={user.fullName}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='phone'
                label={t('Phone')}
                required={true}
                onChange={this.onChange}
                placeholder={t('Enter phone number to login')}
                isDisabled={disabled}
                value={user.phone}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <SelectField
                name='userRole'
                label={t('User role')}
                placeholder={t('Select user role')}
                isMulty={false}
                value={user.userRole}
                required={true}
                onChange={this.onChange}
                data={dictionaries.userRoles.data}
                fetching={dictionaries.userRoles.fetching}
                getData={getDictionaries('userRoles')}
                isDisabled={disabled}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <SelectField
                name='dealer'
                label={t('Company')}
                placeholder={t('Select company')}
                value={user.dealer}
                required={true}
                onChange={this.onChange}
                data={dictionaries.companies.data}
                fetching={dictionaries.companies.fetching}
                getData={getDictionaries('companies')}
                isDisabled={disabled}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='position'
                label={t('Position')}
                required={true}
                onChange={this.onChange}
                placeholder={t("Enter user's position")}
                isDisabled={disabled}
                value={user.position}
              />
            </GridColumn>

            <GridColumn>
              <FormFooter>
                <ButtonGroup>
                  {!isNew && permissions.delete && (
                    <Button
                      appearance='subtle'
                      isDisabled={fetching}
                      onClick={this.onDelete}
                    >
                      <span style={{color: !fetching && 'red'}}>
                        {t('common:Remove')}
                      </span>
                    </Button>
                  )}
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>{t('common:Cancel')}</Button>
                  {!hideControl && (
                  <Button type='submit' isDisabled={disabled} isLoading={fetching} appearance='danger'>
                     {t(isNew ? 'common:Create' : 'common:Save')}
                  </Button>
                  )}
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.user,
    user: state.user.data,
    fetching: state.user.fetching,
    error: state.user.error,
    dictionaries: state.dictionaries, 
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(UserActions.userRequest(id)),
    create: data => dispatch(UserActions.userAddRequest(data)),
    update: data => dispatch(UserActions.userUpdateRequest(data)),
    delete: id => dispatch(UserActions.userDeleteRequest(id)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('users', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserPage));
